import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './StoreList';

const StoreListSuspense = dynamic(() => import('./StoreList'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicStoreList(props: Props) {
	return <StoreListSuspense {...props} />;
}
DynamicStoreList.displayName = 'DynamicStoreList';
